import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
export default (function (props, _ref) {
  var $ = _ref.$,
      $h = _ref.$h,
      $el = _ref.$el,
      $f7 = _ref.$f7,
      $update = _ref.$update,
      $tick = _ref.$tick;
  var rows = [],
      $f,
      $t;

  var list = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var from_date, to_date, f, t, diff, i, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              rows = [];
              from_date = $f.val();
              to_date = $t.val(); //Hiển thị ngày

              f = moment(from_date, 'D/M/YYYY');
              t = moment(to_date, 'D/M/YYYY');
              diff = t.diff(f, 'days');

              if (!(diff < 0 || diff > 90)) {
                _context.next = 9;
                break;
              }

              $f7.dialog.alert('Chọn khoảng thời gian < 90 ngày');
              return _context.abrupt("return", false);

            case 9:
              for (i = 0; i <= diff; i++) {
                rows.push({
                  date: t.clone().subtract(i, 'days').format('ddd D/M'),
                  working_date: t.clone().subtract(i, 'days').format('YYYY-MM-DD'),
                  approvals: [],
                  denials: []
                });
              }

              $f7.dialog.preloader('Đang tải...');
              _context.next = 13;
              return Base.api('Dayoff', 'list', {
                from_date: from_date,
                to_date: to_date
              });

            case 13:
              rs = _context.sent;
              $f7.dialog.close();

              if (!(rs.rows.length === 0 && rs.denied_rows.length === 0)) {
                _context.next = 18;
                break;
              }

              $update();
              return _context.abrupt("return", false);

            case 18:
              rows.map(function (wc) {
                rs.rows.filter(function (r) {
                  return r.working_date === wc.working_date;
                }).map(function (row) {
                  return wc.approvals.push(row);
                });
                rs.denied_rows.filter(function (r) {
                  return r.working_date === wc.working_date;
                }).map(function (row) {
                  return wc.denials.push(row);
                });
              });
              $update();

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function list() {
      return _ref2.apply(this, arguments);
    };
  }();

  var remove = function remove(row) {
    if (Base.user.id != row.id_emp) return false;

    var rm = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(row) {
        var rs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $f7.dialog.preloader('Đang huỷ...');
                _context2.next = 3;
                return Base.api('Dayoff', 'remove', {
                  data: row
                });

              case 3:
                rs = _context2.sent;
                list();
                $f7.dialog.close();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function rm(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    var message = row.status === 1 ? 'Lịch đã được đuyệt. ' : '';
    $f7.dialog.confirm(message + 'Bạn chắc chắn muốn huỷ?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", rm(row));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
  };

  $tick(function (_) {
    $f = $el.value.find('input[name="from_date"]');
    $t = $el.value.find('input[name="to_date"]');
    $f7.calendar.create({
      inputEl: $f,
      dateFormat: 'd/m/yyyy',
      closeOnSelect: true
    });
    $f7.calendar.create({
      inputEl: $t,
      dateFormat: 'd/m/yyyy',
      closeOnSelect: true
    });
    $f.change(function (_) {
      return list();
    });
    $t.change(function (_) {
      return list();
    });
    list();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="dayoff">
  <div class="toolbar toolbar-bottom">
      <div class="toolbar-inner">
        <a href="/dayoff-popup/" class="button">XIN NGHỈ</a>
      </div>
    </div>
  <div class="page-content">
    <div class="list no-margin">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Từ ngày</div>
            <div class="item-input-wrap">
              <input type="text" name="from_date" value="${moment().weekday(1).format(Base.dateFormat)}" readonly />
            </div>
          </div>
          <div class="item-inner">
            <div class="item-title item-label">Đến ngày</div>
            <div class="item-input-wrap">
              <input type="text" name="to_date" value="${moment().weekday(7).format(Base.dateFormat)}" readonly />
            </div>
          </div>
        </li>
      </ul>
    </div>

    

    <div class="row margin">
      <div class="col">Nhân viên</div>
      <div class="col text-align-right">Gửi lúc</div>
    </div>
    ${rows.length > 0 && rows.map(row=>$h`
      
      <h2 class="margin-half text-color-orange text-align-center" style="text-transform: uppercase;">${row.date}</h2>
      <div class="margin-half">
        ${row.approvals.length > 0 && $h`<div><span class="text-color-green">ĐÃ DUYỆT</span>/Chưa duyệt:</div>`}
        ${row.approvals.length > 0 && row.approvals.map(a=>$h`
          <div class="row padding dayoff-row-border ${Base.user.id === a.id_emp && 'dayoff-row-me'}" data-id="${a.id}" key="${a.id}" @click="${e=>remove(a)}">
            <div class="col">${a.status ? $h`<i class="f7-icons text-color-green" style="font-size: 14px;">checkmark_circle_fill</i>` : $h`<i class="f7-icons" style="font-size: 14px; color:white">question_circle_fill</i>`} ${a.name}</div>
            <div class="col text-align-right">${moment(a.created_date).format('D/M/YY HH:mm')}</div>
          </div>
        `)}
        ${row.denials.length > 0 && $h`<div class="text-color-red margin-top-half">KHÔNG DUYỆT:</div>`}
        ${row.denials.length > 0 && row.denials.map(b=>$h`
          <div class="row padding dayoff-row-border ${Base.user.id === b.id_emp && 'dayoff-row-me'}" data-id="${b.id}" key="${b.id}">
            <div class="col"><i class="f7-icons text-color-red" style="font-size: 14px;">multiply_circle_fill</i> ${b.name}</div>
            <div class="col text-align-right">${moment(b.request_at).format('D/M/YY HH:mm')}</div>
          </div>
        `)}
      </div>
      <div style="margin-bottom: 20px;"></div>
    `)}

  </div>
</div>
`
    }
    ;
});